import { rankWith, isDateControl } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { FormItem } from '../../../../../controls/FormItem';
import { AntDatepicker } from '../../../../../controls/AntDatePicker';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';
import { get } from 'lodash';

const DateControl = ({
  path,
  label,
  data,
  handleChange,
  handleRemove,
  handleBlur,
  required,
  schema,
  uischema,
  disabled,
  formData,
  optionalMessage,
}: FieldProps) => {
  const minDate = uischema.options?.minDate;
  const maxDate = uischema.options?.maxDate;
  const moreInfo = uischema.options?.moreInfo;
  const minDatePath = uischema.options?.minDatePath;
  const minDateValue = get(formData, minDatePath);

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-datepicker-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <div>
        <AntDatepicker
          value={data}
          onBlur={() => {
            if (data) {
              handleChange(path, data);
            } else {
              handleRemove(path);
            }
            handleBlur(path);
          }}
          minDateValue={minDateValue}
          onChange={(_, d) => {
            if (d) {
              handleChange(path, d);
            } else {
              handleRemove(path);
            }
          }}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
        />
        {schema.description && (
          <p className="description margin-bottom">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const DatepickerInputControlEntry = {
  tester: rankWith(100, isDateControl),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(DateControl)),
};
